export default __webpack_public_path__ + "static/DSC_0395-3d3d8f6a7f8ebf93b7445a2d9d6e21a8.jpg";